export const globalparameterConstants = {
    GETALL_REQUEST: 'GLOBALPARAMETER_GETALL_REQUEST',
    GETALL_SUCCESS: 'GLOBALPARAMETER_GETALL_SUCCESS',
    GETALL_FAILURE: 'GLOBALPARAMETER_GETALL_FAILURE',

    DELETE_REQUEST: 'GLOBALPARAMETER_DELETE_REQUEST',
    DELETE_SUCCESS: 'GLOBALPARAMETER_DELETE_SUCCESS',
    DELETE_FAILURE: 'GLOBALPARAMETER_DELETE_FAILURE'
};
